import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { canManageWorkspace } from '@/lib/permissions';

export function WorkspaceAdminRoute() {
  const { user } = useAuth();
  return canManageWorkspace(user?.role) ? <Outlet /> : <Navigate to="/" replace />;
}
